import React from "react";
import './c60_person_simple_email.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class PersonSimpleEmail extends TemplateComponent {

    componentRender(data) {
        // Remove professor Lorena Mazzoni 
        data.professors = data.professors.filter(professor=> professor.title==="Lorena Mazzoni"?false:true)
        return (
            !isMobileOnly ?
                <div id="person-simple">
                    <div className="person-simple-title">{data.title}</div>
                    <div className="container">
                        <div className="row">
                            {data.professors.map((persona, index) => (
                                <div key={index} className="col-sm-3 col-xs-2 person-simple-card">
                                    <div className="person-simple-card-title">{persona.title}</div>
                                    <div className="person-simple-card-subtitle">{persona.subtitle}</div>
                                    <div className="person-simple-card-email"><a href={"mailto:" + persona.email}>{persona.email}</a></div>
                                    <div className="person-simple-card-show-more"><a href={persona.show_more_url}>{persona.show_more_title}</a></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> :
                <div id="person-simple-mob">
                    <div className="person-simple-title">{data.title}</div>
                    <div className="container">
                        <div className="row">
                            {data.professors.map((persona, index) => (
                                <div key={index} className="col-sm-3 col-xs-2 person-simple-card">
                                    <div className="person-simple-card-title">{persona.title}</div>
                                    <div className="person-simple-card-subtitle">{persona.subtitle}</div>
                                    <div className="person-simple-card-email"><a href={"mailto:" + persona.email}>{persona.email}</a></div>
                                    <div className="person-simple-card-show-more"><a href={persona.show_more_url}>{persona.show_more_title}</a></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
        )
    }
}

export default PersonSimpleEmail;
